import { useUser } from './index'

export const useUserTimeZone = () => {
  const { user } = useUser()

  return user?.timeZone || 'America/Chicago'
}
